var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4142 15.5858C15.6332 14.8047 14.3668 14.8047 13.5858 15.5858C12.8047 16.3668 12.8047 17.6332 13.5858 18.4142L18.1716 23L13.5858 27.5858C12.8047 28.3668 12.8047 29.6332 13.5858 30.4142C14.3668 31.1953 15.6332 31.1953 16.4142 30.4142L21 25.8284L25.5858 30.4142C26.3668 31.1953 27.6332 31.1953 28.4142 30.4142C29.1953 29.6332 29.1953 28.3668 28.4142 27.5858L23.8284 23L28.4142 18.4142C29.1953 17.6332 29.1953 16.3668 28.4142 15.5858C27.6332 14.8047 26.3668 14.8047 25.5858 15.5858L21 20.1716L16.4142 15.5858Z",
    fill: "#F42C04"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.e36d7311e1f6294e6cc7d1ca2735a096.svg";
export { ForwardRef as ReactComponent };